import { atom } from "jotai";
import { AdminUser } from "../models/adminUser";
import { LoginType } from "../models/enum/login";

export const userAtom = atom<AdminUser | undefined>(undefined);

export const isBackstageUserAtom = atom((get) => {
  const admin = get(userAtom);
  return admin?.source === LoginType.BACKSTAGE;
});
